import { useState,useEffect } from "react"
import style from "./controlPanel.module.scss"
import axios from "axios"


const MenuScreens = ({ setting, setSetting }) => {
	const [idx, setIdx] = useState(0)

	const selectScreen = row =>{
		setSetting({
			...setting,
			screen:row,
		})
	}	

	const [rows, setRows] = useState([]);
	const [totPage, setTotPage] = useState(1);

	useEffect(() => {
		async function getTotalPage() {
		  const total = await axios.get(
			`${process.env.REACT_APP_PUBLIC_API_URL}/screens/page`
		  );
		  setTotPage(total.data.page);
		  await handlePage([], 1);
		}
		getTotalPage();

		setSetting({
			...setting,
			imagechg : 0,
		})
	}, [setting && setting.imagechg? setting.imagechg:null]);	

	const handlePage = async (_, value) => {
		try {
			const resp = await axios.get(
			`${process.env.REACT_APP_PUBLIC_API_URL}/screens?page=${value}`
			);
			if(resp.data.data)setRows(resp.data.data);
			else{
			}
		}catch (err) {
			alert(err);
		}
	};	

	function StopRow({row}) {
		const fetchImage = async () => {
			try {

				const resp = await axios.get( `${process.env.REACT_APP_PUBLIC_API_URL}/downloadfile`,{
					responseType: 'blob', // blob 형식으로 응답을 받음
					params: {
						filename: row.filename,
					},
				});
				if(resp.data){
					const url = URL.createObjectURL(resp.data);
					return (
						<div key={row.id} style={{ display: 'flex', marginTop:'1px'}}>
							<div style={{  flex: '60%', width:'120px', marginTop:'5px'}}>	
								<button onClick={() => selectScreen(row)}>{row.screenno}</button>
								<span style={{color:'#D7BA5F'}}> {row.screenname}</span>
							</div>
							<div style={{  flex: '40%', marginTop:'3px'}}>	
								<img
									src={url}
									// width={240}
									// height={40}
									//layout='fixed'
									quality={35}
									objectFit='cover'
									margin={10}
								/>	
							</div>
							{/* <button style={{marginLeft:'-2px',color:'#88D084'}} onClick={() => selectScreen(row)}>{row.filename}</button> */}
							{/* <button style={{marginLeft:'-2px', marginRight:'-5px',color:'#D7BA5F'}} onClick={() => selectScreen(row)}>{row.screenname}</button> */}
						</div>		
					);
				}
			} catch (error) {
				console.error('Error fetching image:', error);
			}
		};

		fetchImage();
		return (
			<div key={row.id} style={{ display: 'flex', marginTop:'1px'}}>
				<div style={{  flex: '60%', width:'120px', marginTop:'5px'}}>	
					<button onClick={() => selectScreen(row)}>{row.screenno}</button>
					<span style={{color:'#D7BA5F'}}> {row.screenname}</span>
				</div>
				<div style={{  flex: '40%', marginTop:'3px', marginRight:'10px'}}>	
					<img
						src={`${process.env.REACT_APP_PUBLIC_URL}/download/${row.filename}`}
						width={180}
						height={40}
						layout='fixed'
						quality={75}
						objectFit='cover'
						margin={10}
					/>	
				</div>
				{/* <button style={{marginLeft:'-2px',color:'#88D084'}} onClick={() => selectScreen(row)}>{row.filename}</button> */}
				{/* <button style={{marginLeft:'-2px', marginRight:'-5px',color:'#D7BA5F'}} onClick={() => selectScreen(row)}>{row.screenname}</button> */}
			</div>		
		);
	};			

	return <>
		<div
			className={style.controlPanelInfo}
			style={{overflow: 'scroll'}}
		>
		{rows.map((row) => (
			<StopRow key={row.id}
				row={row}
			/>
		))}
		</div>
	</>
}

export default MenuScreens
